import React from "react";
// react admin
import { TextInput, useGetIdentity, required } from "react-admin";
// mui
import { Dialog, Grid } from "@mui/material";
import { EditForm } from "../../../Layout/EditForm";

const EditUserForm = ({ handleClose, id, resource }) => {
  return (
    <EditForm
      title="Edit User Profile"
      handleClose={handleClose}
      id={id}
      resource={resource}
    >
      <Grid item xs={12}>
        <TextInput
          source="name"
          id="name"
          name="name"
          type="text"
          fullWidth
          validate={[required()]}
        />
      </Grid>
    </EditForm>
  );
};

export const EditProfile = ({ open, onClose }) => {
  const { data } = useGetIdentity();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onClick={(evt) => evt.stopPropagation()}
    >
      <EditUserForm handleClose={onClose} id={data?.userId} resource="users" />
    </Dialog>
  );
};
